<template>
	<div class="letters">
		<p v-for="item in letters" :key="item.key">{{ item }}</p>
	</div>
</template>

<script>
export default {
	name: 'letters',
	props: {
		letters: String,
	},
};
</script>
